export default __webpack_public_path__ + "static/media/the_something_bacon_and_bleu.bb9ab88a.jpg";